import Images from "src/theme/Images";

export const HOME_WISHLIST_EX = [
  {
    file: Images.exWishImage1,
  },
  {
    file: Images.exWishImage2,
  },
  {
    file: Images.exWishImage3,
  },
  {
    file: Images.exWishImage4,
  },
  {
    file: Images.exWishImage5,
  }
];
export const WISHLIST_EX = [
  {
    file: Images.exWishImage1,
    item_name: 'SMEG CREAM DRIP COFFEE MAKER',
    price: 199.35
  },
  {
    file: Images.exWishImage2,
    item_name: 'CROSS BAND SOFT PLUSH...',
    price: 23.99
  },
  {
    file: Images.exWishImage3,
    item_name: 'MOSCOW MULE MUG',
    price: 19.5
  },
  {
    file: Images.exWishImage4,
    item_name: 'MICROPLANE MASTER...',
    price: 150
  }
];
export const RECEIVED_EX = [
  {file: Images.exProdImage1},
  {file: Images.exProdImage2},
  {file: Images.exProdImage3},
  {file: Images.exProdImage4},
  {file: Images.exProdImage5},
  {file: Images.exProdImage6},
  {file: Images.exProdImage7},
];
export const FRIEND_EX = [
  {picture: Images.exUserImage1, fullname: 'NICOLE GAUPER'},
  {picture: Images.exUserImage2, fullname: 'ALEX REED'},
  {picture: Images.exUserImage6, fullname: 'GWYNETH MARTIN'},
  {picture: Images.exUserImage4, fullname: 'CARA JONES'},
];
export const FOLLOWING_EX = [
  {picture: Images.exFollowing1, fullname: 'SARAH MOORE'},
  {picture: Images.exFollowing2, fullname: 'JOSIE LANE'},
  {picture: Images.exFollowing3, fullname: 'JOE JOHNSON'},
  {picture: Images.exFollowing4, fullname: 'ALEXA BERRY'},
  {picture: Images.exFollowing5, fullname: 'MARTIN SMITH'},
  {picture: Images.exFollowing6, fullname: 'CARLA WILLIAMS'},
  {picture: Images.exFollowing7, fullname: 'JACOB MILLER'}
];
export const MY_EVENTS_EX = [
  {
    month: 1,
    day: '23',
    event_name: 'Birthday'
  },
  {
    month: 2,
    day: 24,
    event_name: 'Housewarming Party'
  },
]
export const EVENT_EX = [
  {
    picture: Images.exUserImage1,
    month: 1,
    day: '07',
    event_name: 'Housewarming Party',
    username: 'Nicole Gauper',
  },
  {
    picture: Images.exUserImage2,
    month: 1,
    day: 23,
    event_name: 'Wedding',
    username: 'Alex Reed',
  },
  {
    picture: Images.exUserImage3,
    month: 5,
    day: 12,
    event_name: 'Birthday',
    username: 'Sarah Johnson',
  },
  {
    picture: Images.exUserImage4,
    month: 6,
    day: 15,
    event_name: 'Graduation',
    username: 'Cara Jones',
  },
  {
    picture: Images.exUserImage5,
    month: 7,
    day: 17,
    event_name: 'Anniversary',
    username: 'Gary Smith',
  },
  {
    picture: Images.exUserImage6,
    month: 9,
    day: 18,
    event_name: 'Baby Due Date',
    username: 'Gwyneth Martin',
  },
];
export const USER_EX = [
  {picture: Images.exUserImage1, fullname: 'Nicole Gauper'},
  {picture: Images.exUserImage2, fullname: 'Alex Reed'},
  {picture: Images.exUserImage5, fullname: 'Sarah Johnson'},
  {picture: Images.exUserImage4, fullname: 'Cara Jones'},
  {picture: Images.exUserImage6, fullname: 'Gwyneth Martin'},
];